<template>
  <div class="info-modal-backdrop">
    <div id="info_modal" class="info-modal">
      <div class="info-scrollbox">
        <div>
          <span class="is-size-3 has-text-left has-text-dark">Information</span>
          <span class="is-size-3 is-pulled-right has-text-right"><a class="info-header-close" @click="close"><i class="fas fa-times-circle"></i></a></span>
        </div>
        <P>Rankings since first of current month.</p>
        <p>ALWAYS use honesty.</p>
        <p>Ranking placements determined by average throws.</p>
        <!--
        <ul style="list-style-type: circle; padding: 10px;">
          <li>Rankings are based on weekly average</li> 
          <li>Averages refresh each week (Friday 6 AM GMT)</li> 
          <li>Rankings refresh each week (Friday 6 AM GMT)</li>
          <li>Retrieve past results below</li>
          <li>ALWAYS use honesty</li>
        </ul>
        -->
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.info-header-close {
  color: red !important;
}
.info-modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-Index: 1000;
}
.info-modal {
  font-family: Verdana;
  padding: 20px;
  border-radius: 25px !important;
  background: silver;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 80%;
  height: 80%;
}
.info-scrollbox {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 20px;
}
</style>

<script>
export default {
  name: "InfoModal",
  props: {
      scorecard: null
  },
  methods: {
    close() {
      this.$emit("close");
    }
  },
  mounted(){
  }
};
</script>
